<template>
	<section class="provider-selector">
		<header>
			<h2>{{ t("contactResearchPage.sources.title") }}</h2>
			<span>
				{{
					t("contactResearchPage.sources.selectedOfTotal", {
						selected: selectedProviderIds.length,
						total: providers.length,
					})
				}}
			</span>
		</header>
		<p v-if="loading" class="state">{{ t("contactResearchPage.sources.loading") }}</p>
		<div v-else class="providers">
			<ProviderCard
				v-for="provider in providers"
				:key="provider.id"
				:provider="provider"
				:description="t(`contactResearchPage.sources.descriptions.${provider.id}`)"
				:selected="selectedProviderIds.includes(provider.id)"
				@toggle="emit('toggle', provider.id)"
			/>
		</div>
	</section>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import ProviderCard from "@/components/contact-research/ProviderCard.vue"
import type { ContactResearchProviderId, ContactResearchProviderInfo } from "@/types/contactResearch"

defineProps<{
	providers: ContactResearchProviderInfo[]
	selectedProviderIds: ContactResearchProviderId[]
	loading: boolean
}>()

const emit = defineEmits<{
	toggle: [providerId: ContactResearchProviderId]
}>()

const { t } = useI18n()
</script>

<style scoped>
.provider-selector {
	margin-top: var(--space-24);

	> header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--space-12);
		margin-bottom: var(--space-12);

		h2,
		span {
			margin: 0;
			font-size: var(--font-size-xs);
			color: var(--neutral-600);
		}

		h2 {
			font-weight: var(--font-weight-semibold);
			text-transform: uppercase;
			letter-spacing: 0.04em;
		}
	}
}

.providers {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: var(--space-10);
}

.state {
	margin: var(--space-20) 0 0;
	color: var(--neutral-600);
	font-size: var(--font-size-small);
}

@media (max-width: 640px) {
	.providers {
		grid-template-columns: 1fr;
	}
}
</style>
